/**
 * Route for `published-sub-processor-list`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublishedSubProcessorListPage } from "../features/published-sub-processor-list/PublishedSubProcessorListPage";

export const publishedSubProcessorListRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/published-sub-processor-list",
	component: PublishedSubProcessorListPage,
});

export default publishedSubProcessorListRoute;
